import { Appointment } from '@myapp/contract'
import {
  APPOINTMENT_DEFAULT_DEPARTURE_MINUTES,
  APPOINTMENT_DEFAULT_TRAVEL_MINUTES,
  APPOINTMENT_DEFAULT_WORK_MINUTES,
  useUpdateAppointment,
} from '../../../entities/appointment'
import { workOrderAddress } from '../../../shared/helpers/address'
import { CalendarPlanningOverlay, timedPlannedStartOrNull } from '../../calendar-planning-overlay'

interface Props {
  show: boolean
  onClose: () => void
  onSuccess: () => void
  appointment: Appointment
  technicianId: number
}

export function WorkerAppointmentReschedulePlanOverlay({
  show,
  onClose,
  onSuccess,
  appointment,
  technicianId,
}: Props) {
  const updateAppointment = useUpdateAppointment()

  const initialSelectedDate = timedPlannedStartOrNull(appointment.schedule.plannedWorkStartsAt)

  return (
    <CalendarPlanningOverlay
      show={show}
      onClose={onClose}
      technicianId={technicianId}
      initialSelectedDate={initialSelectedDate}
      initialWorkDuration={appointment.schedule.plannedWorkMinutes ?? APPOINTMENT_DEFAULT_WORK_MINUTES}
      initialTravelDuration={appointment.schedule.plannedTravelMinutes ?? APPOINTMENT_DEFAULT_TRAVEL_MINUTES}
      initialDepartureDuration={
        appointment.schedule.plannedDepartureMinutes ?? APPOINTMENT_DEFAULT_DEPARTURE_MINUTES
      }
      excludeAppointmentId={appointment.id}
      headerTitle="Termin umplanen"
      saveButtonColor="#124093"
      draftTitle={workOrderAddress(appointment.workOrder?.external) ?? 'Termin'}
      hintText="Tippe auf eine Uhrzeit im Kalender, um den Termin zu setzen"
      onSave={async (payload) => {
        await updateAppointment.mutateAsync({
          id: appointment.id,
          dto: {
            plannedStart: payload.plannedStart,
            plannedWorkDuration: payload.plannedWorkDuration,
            plannedTravelDuration: payload.plannedTravelDuration,
            plannedDepartureDuration: payload.plannedDepartureDuration,
          },
        })
        onSuccess()
      }}
      isPending={updateAppointment.isPending}
    />
  )
}
